// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vth9","top":"styles_top__2mYF4","left":"styles_left__2F84L","description":"styles_description__1qJRW"};